import axios from 'axios';

export default class SingleCarCalculator {
    constructor() {
        this.token = "3LT4dTVMoGwRn";
        this.calculator = document.querySelector('[data-calculator]');
        this.calculator_form = document.querySelector('[data-calculator-html-form]');
        this.current_payment_type = 'credit';
        this.vw_api_endpoint = 'https://kalkulator.vwbank.pl/vwapi/calculate/';
        this.vw_api_proxy_endpoint = window?.ajax_object?.restUrlVwBankProxy ?? '';
        this.calculator_data = {};
    }

    init() {
        if (!this.checkPageType() || !this.calculator) {
            return false;
        }

        this.autoCalculate();

        const form_inputs = this.calculator_form.querySelectorAll('input');
        [...form_inputs].forEach((input) => {
            input.addEventListener('change', (e) => {
                e.preventDefault();
                this.getFormData();
                this.getCalculateFromVWBank(this.current_payment_type);
            })
        });

        this.calculator_form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.getFormData();
            this.getCalculateFromVWBank(this.current_payment_type);
        })

        this.updateTabView();
        this.calculatorTabs();
    }

    autoCalculate() {
        this.getFormData();
        this.getCalculateFromVWBank('credit');
        this.getCalculateFromVWBank('leasing');
    }

    getFormData() {
        // Reset data
        this.calculator_data = {};

        // Set New data
        this.calculator_data = {
            'token': this.token,
            'model': this.capitalizeFirstLetter(this.calculator_form.dataset.calculatorModel),
            'price': this.calculator_form.dataset.calculatorPrice,
            'km_limit': (this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_limit"]').value) * 1000,
            'rate': this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_loans"]').value,
            'payment': (this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value) / 100,
            'own_contribution' : (parseFloat(this.calculator_form.dataset.calculatorPrice) * parseFloat(this.calculator_form.querySelector('input[name="' + this.current_payment_type + '_own-contribution"]').value)) / 100,
        };

        console.log(this.calculator_data);
    }

    capitalizeFirstLetter(string) {
        if (!string) return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    notifyCalculatorStartedLoading() {
      const event = new CustomEvent('calculator-started-loading', {});
      window.dispatchEvent(event);
    }

    notifyCalculatorFinishedLoading() {
      const event = new CustomEvent('calculator-finished-loading', {});
      window.dispatchEvent(event);
    }

  //https://kalkulator.vwbank.pl/vwapi/calculate/skoda_leasing_niskich_rat/
    //https://kalkulator.vwbank.pl/vwapi/calculate/skoda/

    getCalculateFromVWBank(payment_type) {
      this.notifyCalculatorStartedLoading();

      // const endpoint = (payment_type == 'credit') ? 'skoda/' : 'skoda_leasing_niskich_rat/';
      // const url = this.vw_api_endpoint + endpoint;


      const endpoint = (payment_type == 'credit') ? 'skoda' : 'skoda_leasing_niskich_rat';
      const url = this.vw_api_proxy_endpoint + '?endpoint=' + endpoint;

        let formData = new FormData();
        formData.append('token', this.calculator_data.token);
        formData.append('model', this.calculator_data.model);
        formData.append('price', this.calculator_data.price);
        formData.append('km_limit', this.calculator_data.km_limit);
        formData.append('rate', this.calculator_data.rate);
        formData.append('payment', this.calculator_data.payment);

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }

        let that = this;

        axios.post(url, formData, config).then(function (response) {
            console.log(response);
            const notAvailableText = '<span class="text-lg text-[#ff0000]">Kombinacja niedostępna!</span>';

            if(payment_type == 'credit') {
                that.animateNumber(document.querySelector('[data-own-contribution="credit"]'), that.calculator_data.own_contribution)
                const rate = response?.data?.content?.rate ?? null;
                const rateField = document.querySelector('[data-loan-brutto="credit"]');

                if (rate !== null) {
                  that.animateNumber(rateField, response.data.content.rate)
                } else {
                  rateField.innerHTML = notAvailableText;
                }
            } else {
                that.animateNumber(document.querySelector('[data-own-contribution="leasing"]'), that.calculator_data.own_contribution);

                const rate = response?.data?.content?.rate ?? null;
                const rateField = document.querySelector('[data-loan-brutto="leasing"]');
                if (rate !== null) {
                  that.animateNumber(rateField, response.data.content.rate);
                } else {
                  rateField.innerHTML = notAvailableText;
                }

                const redemptionValue = response?.data?.content?.redemption_value ?? null;
                const redemptionField = document.querySelector('[data-end-value-brutto="leasing"]');
                if (redemptionValue !== null) {
                  that.animateNumber(redemptionField, response.data.content.redemption_value);
                } else {
                  redemptionField.innerHTML = notAvailableText;
                }
            }
        }).finally(()=> {
          this.notifyCalculatorFinishedLoading();
        });
    }

    animateNumber(elem,value) {
        let current = elem.dataset.currentValue;
        let new_value = parseInt(value);
        elem.innerText = this.formatPrice(new_value) + ' zł';
    }

    formatPrice(price) {
      // format 1000 to 1 000
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    calculatorTabs() {
        const options = this.calculator.querySelectorAll('[data-payment-option]');
        [...options].forEach((option) => {
            option.addEventListener('click', (e) => {
                e.preventDefault();
                this.current_payment_type = option.dataset.paymentOption;
                this.updateTabView();
            })
        });
    }

    updateTabView() {
        const options = this.calculator.querySelectorAll('[data-payment-option]');
        [...options].forEach((option) => {
            option.classList.remove('bg-secondary','border-b-primary', 'before', 'before:absolute', 'before:bottom-0', 'before:left-0', 'before:w-full', 'before:h-1', 'before:bg-primary', 'text-white');

            if (option.dataset.paymentOption === this.current_payment_type) {
                option.classList.add('bg-secondary','border-b-primary', 'before', 'before:absolute', 'before:bottom-0', 'before:left-0', 'before:w-full', 'before:h-1', 'before:bg-primary', 'text-white');
                option.classList.remove('text-grayscale-800');
            }
        })

        // Set Tab Active
        const tabs = this.calculator_form.querySelectorAll('[data-payment-tab]');
        [...tabs].forEach((tab) => {
            tab.style.display = 'none';

            if (tab.dataset.paymentTab === this.current_payment_type) {
                tab.style.display = 'block';
            }
        })
    }

    checkPageType() {
        if (document.body.classList.contains('single-car')) {
            return true;
        }
        return false;
    }
}
